export default __webpack_public_path__ + "static/media/congo.97b872c1.gif";